// extracted by mini-css-extract-plugin
module.exports = {"root":"simple-title-module--root--hZJrD","text":"simple-title-module--text--3EPAu","buttonWrapper":"simple-title-module--buttonWrapper--29Dmz"};